import React from 'react';
import { createUseStyles } from 'react-jss';
import { DiaryEmpty } from '../../assets/vectors';
import Theme from '../../constants/Theme';

const GlobalEmptyState = () => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <DiaryEmpty />
      <p className={classes.description}>
        Es bestehen noch keine Hörtagebucheinträge oder <br />
        sie werden derzeit nicht mit dem Fachgeschäft geteilt.
      </p>
    </div>
  );
};

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    height: '844px',
  },
  description: {
    fontSize: '18px',
    color: Theme.colors.blue,
    textAlign: 'center',
    fontWeight: 'bold',
    fontFamily: Theme.typography.fontFamily,
    lineHeight: '22px',
  },
});

export default GlobalEmptyState;
